import { render, staticRenderFns } from "./MessageAttachment.vue?vue&type=template&id=6c63f44e&scoped=true"
import script from "./MessageAttachment.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageAttachment.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessageAttachment.vue?vue&type=style&index=0&id=6c63f44e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c63f44e",
  null
  
)

export default component.exports